import { inject } from '@angular/core';
import { SnackbarService } from '@services/snackbar.service';
import {
    HttpInterceptorFn,
    HttpRequest,
    HttpHandlerFn,
    HttpErrorResponse,
} from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ErrorDisplayKind } from '@constants/error-code';

export const errorToastInterceptor: HttpInterceptorFn = (
    req: HttpRequest<any>,
    next: HttpHandlerFn,
) => {
    const snackbar = inject<SnackbarService>(SnackbarService);

    return next(req).pipe(
        catchError((response: HttpErrorResponse) => {
            if (response.error?.displayKind === ErrorDisplayKind.TOAST) {
                const header = response.error.title || 'Operation Failed';
                const errorMessage = `${response.error.detail} Please open a ticket to resolve the issue or reach out to your account admin with error code: ${response.error.errorCode}`;
                snackbar.error({
                    variant: 'error',
                    header: header,
                    content: errorMessage,
                });
            }
            return throwError(() => response);
        }),
    );
};
